/* eslint-disable */
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const BillableActivityListHeader = ({
  reloadList = () => {},
  selectedItemIds = [],
  jsonFilterQuery = [],
  onAddNew = () => {}, // ✅ VALOR POR DEFECTO AGREGADO
  onDelete = () => {}, // ✅ VALOR POR DEFECTO AGREGADO
  onOpenPivot = () => {},
  onExportCSV = () => {}, // ✅ VALOR POR DEFECTO AGREGADO
  onExportPDF = () => {}, // ✅ VALOR POR DEFECTO AGREGADO
  currentTab = 0,
  filteredActivitiesList = [],
  selectedActivityIds = []
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const breadcrumbText = [
    {
      title: t("Clinical Management"),
      link: "/admin/clinicalmanagement/billableactivities",
    },
    { title: t("Billable Activity") },
  ];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* Refresh */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">refresh</span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>

          {/* Action Dropdown */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">expand_more</span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  to="#"
                  data-bs-toggle={selectedItemIds.length === 0 ? undefined : "modal"}
                  data-bs-target={selectedItemIds.length === 0 ? undefined : "#manageLabelModal"}
                >
                  <span className="d-block material-symbols-outlined icon-sm">label</span>
                  <span className="d-block">{t("Manage Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">progress_activity</span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (selectedItemIds.length > 0 && onExportCSV) {
                      onExportCSV();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">download</span>
                  <span className="d-block">{t("Export to CSV")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (selectedItemIds.length > 0 && onExportPDF) {
                      onExportPDF();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">picture_as_pdf</span>
                  <span className="d-block">{t("Export to PDF")}</span>
                </Link>
              </li>
              <hr className="dropdown-divider" />
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0 ? "disabled text-muted" : "text-danger"
                  }`}
                  to="#"
                  onClick={(e) => {
                    if (selectedItemIds.length > 0) {
                      e.preventDefault();
                      if (onDelete) onDelete();
                    }
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">delete</span>
                  <span className="d-block">{t("Delete")}</span>
                  {selectedItemIds.length > 0 && (
                    <span className="badge bg-danger ms-auto">{selectedItemIds.length}</span>
                  )}
                </Link>
              </li>
            </ul>
          </div>

          {/* Filter */}
          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0 ? "btn-outline-primary" : "btn-light border"
            } d-flex align-items-center px-3 py-2 rounded-3 shadow-sm`}
            title={t("Filter")}
            data-bs-toggle="offcanvas"
            data-bs-target="#billableActivityAdvFilter"
            aria-controls="billableActivityAdvFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs d-flex align-items-center justify-content-center"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>

          {/* Botones condicionales según tab */}
          {currentTab === 0 ? (
            // Tab 0: Potential Activities - Mostrar "Add New"
            <button
              onClick={() => {
                if (selectedItemIds.length > 0 && onAddNew) {
                  onAddNew();
                }
              }}
              disabled={selectedItemIds.length === 0}
              className={`btn ${
                selectedItemIds.length === 0 ? "btn-secondary" : "btn-primary"
              } d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold`}
              style={{
                opacity: selectedItemIds.length === 0 ? 0.6 : 1,
                cursor: selectedItemIds.length === 0 ? "not-allowed" : "pointer"
              }}
            >
              <span className="material-symbols-outlined icon-md">add</span>
              <span>{t("Add New")}</span>
              {selectedItemIds.length > 0 && (
                <span className="badge bg-white text-primary ms-1" style={{ fontSize: "12px" }}>
                  {selectedItemIds.length}
                </span>
              )}
            </button>
          ) : (
            // Tab 1+: Mostrar "Pivot Table"
            <button
              onClick={() => {
                console.log('📊 Opening Pivot with data:', {
                  total: filteredActivitiesList.length,
                  selected: selectedActivityIds.length
                });
                
                history.push({
                  pathname: '/admin/clinicalmanagement/billableactivities/pivot',
                  state: {
                    activities: filteredActivitiesList || [],
                    selectedActivities: selectedActivityIds || []
                  }
                });
              }}
              className="btn d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
              style={{
                backgroundColor: '#ff6347',
                borderColor: '#ff6347',
                color: 'white'
              }}
            >
              <span className="material-symbols-outlined icon-md">bar_chart</span>
              <span>{t("Pivot Table")}</span>
              {selectedActivityIds.length > 0 && (
                <span className="badge ms-1" style={{ 
                  backgroundColor: 'white', 
                  color: '#ff6347',
                  fontSize: "12px" 
                }}>
                  {selectedActivityIds.length}
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillableActivityListHeader;